import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { view as view_3, update as update_1, init as init_1, Model_$reflection as Model_$reflection_1, Msg_$reflection as Msg_$reflection_1 } from "./MainProdQuizzes.fs.js";
import { view as view_1, update as update_2, init as init_2, Model_$reflection as Model_$reflection_2, Msg_$reflection as Msg_$reflection_2 } from "./MainProdQuestions.fs.js";
import { view as view_2, update as update_3, init as init_3, Model_$reflection as Model_$reflection_3, Msg_$reflection as Msg_$reflection_3 } from "./MainProdSettings.fs.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name, record_type, bool_type, union_type, string_type, class_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { empty, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { Cmd_none, Cmd_map } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Infra_clearUserAndSettingsAndRedirect, noCmd } from "./Common.fs.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { Infra_urlForMediaPlain, RESP$1_$reflection } from "../shared/Shared.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { map, singleton, empty as empty_1, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { footerHero } from "./MainTemplates.fs.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ToggleBurger", "Logout", "Quizzes", "Questions", "Settings", "SwitchToQuizzes", "SwitchToQuestions", "SwitchToSettings", "SwitchToDonations", "Exn", "DeleteError"];
    }
}

export function Msg_$reflection() {
    return union_type("MainProd.Msg", [], Msg, () => [[], [], [["Item", Msg_$reflection_1()]], [["Item", Msg_$reflection_2()]], [["Item", Msg_$reflection_3()]], [], [], [], [], [["Item", class_type("System.Exception")]], [["Item", string_type]]]);
}

export class Area extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Quizzes", "Questions", "Settings", "Donations"];
    }
}

export function Area_$reflection() {
    return union_type("MainProd.Area", [], Area, () => [[["Item", Model_$reflection_1()]], [["Item", Model_$reflection_2()]], [["Item", Model_$reflection_3()]], []]);
}

export class Model extends Record {
    constructor(Area, IsBurgerOpen, Errors) {
        super();
        this.Area = Area;
        this.IsBurgerOpen = IsBurgerOpen;
        this.Errors = Errors;
    }
}

export function Model_$reflection() {
    return record_type("MainProd.Model", [], Model, () => [["Area", Area_$reflection()], ["IsBurgerOpen", bool_type], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Area, model.IsBurgerOpen, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt));
}

export function delError(id, model) {
    return new Model(model.Area, model.IsBurgerOpen, FSharpMap__Remove(model.Errors, id));
}

export function init(api, user) {
    const patternInput = init_1(api, user);
    return [new Model(new Area(0, [patternInput[0]]), false, empty({
        Compare: comparePrimitives,
    })), Cmd_map((Item) => (new Msg(2, [Item])), patternInput[1])];
}

export function update(api, user, msg, cm) {
    const matchValue = cm.Area;
    let matchResult, subModel_3, subMsg, subModel_5, subMsg_1, subModel_7, subMsg_2, txt_5, ex;
    switch (msg.tag) {
        case 5: {
            matchResult = 0;
            break;
        }
        case 6: {
            matchResult = 1;
            break;
        }
        case 7: {
            matchResult = 2;
            break;
        }
        case 8: {
            matchResult = 3;
            break;
        }
        case 2: {
            if (matchValue.tag === 0) {
                matchResult = 4;
                subModel_3 = matchValue.fields[0];
                subMsg = msg.fields[0];
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue_2) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 9;
                    txt_5 = activePatternResult;
                }
                else {
                    matchResult = 11;
                }
            }
            break;
        }
        case 3: {
            if (matchValue.tag === 1) {
                matchResult = 5;
                subModel_5 = matchValue.fields[0];
                subMsg_1 = msg.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_3) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 9;
                    txt_5 = activePatternResult_1;
                }
                else {
                    matchResult = 11;
                }
            }
            break;
        }
        case 4: {
            if (matchValue.tag === 2) {
                matchResult = 6;
                subModel_7 = matchValue.fields[0];
                subMsg_2 = msg.fields[0];
            }
            else {
                let activePatternResult_2;
                const msg_3 = msg;
                const pi_1_2 = tryFind((pi_3) => (name(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_2 == null) {
                    activePatternResult_2 = void 0;
                }
                else {
                    const pi$0027_2 = pi_1_2;
                    let msgType_2;
                    let copyOfStruct_2 = msg_3;
                    msgType_2 = Msg_$reflection();
                    if (isUnion(msgType_2)) {
                        const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                        if (objArray_3.length === 1) {
                            try {
                                const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_2 = ((name(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                            }
                            catch (matchValue_4) {
                                activePatternResult_2 = void 0;
                            }
                        }
                        else {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                if (activePatternResult_2 != null) {
                    matchResult = 9;
                    txt_5 = activePatternResult_2;
                }
                else {
                    matchResult = 11;
                }
            }
            break;
        }
        case 0: {
            matchResult = 7;
            break;
        }
        case 1: {
            matchResult = 8;
            break;
        }
        case 9: {
            let activePatternResult_3;
            const msg_4 = msg;
            const pi_1_3 = tryFind((pi_4) => (name(pi_4) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
            if (pi_1_3 == null) {
                activePatternResult_3 = void 0;
            }
            else {
                const pi$0027_3 = pi_1_3;
                let msgType_3;
                let copyOfStruct_3 = msg_4;
                msgType_3 = Msg_$reflection();
                if (isUnion(msgType_3)) {
                    const objArray_4 = getUnionFields(msg_4, msgType_3)[1];
                    if (objArray_4.length === 1) {
                        try {
                            const patternInput_1_3 = getUnionFields(getRecordField(objArray_4[0], pi$0027_3), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                            activePatternResult_3 = ((name(patternInput_1_3[0]) === "Error") ? patternInput_1_3[1][0] : void 0);
                        }
                        catch (matchValue_5) {
                            activePatternResult_3 = void 0;
                        }
                    }
                    else {
                        activePatternResult_3 = void 0;
                    }
                }
                else {
                    activePatternResult_3 = void 0;
                }
            }
            if (activePatternResult_3 != null) {
                matchResult = 9;
                txt_5 = activePatternResult_3;
            }
            else {
                matchResult = 10;
                ex = msg.fields[0];
            }
            break;
        }
        default: {
            let activePatternResult_4;
            const msg_5 = msg;
            const pi_1_4 = tryFind((pi_5) => (name(pi_5) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
            if (pi_1_4 == null) {
                activePatternResult_4 = void 0;
            }
            else {
                const pi$0027_4 = pi_1_4;
                let msgType_4;
                let copyOfStruct_4 = msg_5;
                msgType_4 = Msg_$reflection();
                if (isUnion(msgType_4)) {
                    const objArray_5 = getUnionFields(msg_5, msgType_4)[1];
                    if (objArray_5.length === 1) {
                        try {
                            const patternInput_1_4 = getUnionFields(getRecordField(objArray_5[0], pi$0027_4), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                            activePatternResult_4 = ((name(patternInput_1_4[0]) === "Error") ? patternInput_1_4[1][0] : void 0);
                        }
                        catch (matchValue_6) {
                            activePatternResult_4 = void 0;
                        }
                    }
                    else {
                        activePatternResult_4 = void 0;
                    }
                }
                else {
                    activePatternResult_4 = void 0;
                }
            }
            if (activePatternResult_4 != null) {
                matchResult = 9;
                txt_5 = activePatternResult_4;
            }
            else {
                matchResult = 11;
            }
        }
    }
    switch (matchResult) {
        case 0: {
            const patternInput_6 = init_1(api, user);
            return [new Model(new Area(0, [patternInput_6[0]]), cm.IsBurgerOpen, cm.Errors), Cmd_map((Item) => (new Msg(2, [Item])), patternInput_6[1])];
        }
        case 1: {
            const patternInput_7 = init_2(api, user);
            return [new Model(new Area(1, [patternInput_7[0]]), cm.IsBurgerOpen, cm.Errors), Cmd_map((Item_1) => (new Msg(3, [Item_1])), patternInput_7[1])];
        }
        case 2: {
            const patternInput_8 = init_3(api, user);
            return [new Model(new Area(2, [patternInput_8[0]]), cm.IsBurgerOpen, cm.Errors), Cmd_map((Item_2) => (new Msg(4, [Item_2])), patternInput_8[1])];
        }
        case 3:
            return [new Model(new Area(3, []), cm.IsBurgerOpen, cm.Errors), Cmd_none()];
        case 4: {
            const patternInput_9 = update_1(api, user, subMsg, subModel_3);
            return [new Model(new Area(0, [patternInput_9[0]]), cm.IsBurgerOpen, cm.Errors), Cmd_map((Item_3) => (new Msg(2, [Item_3])), patternInput_9[1])];
        }
        case 5: {
            const patternInput_10 = update_2(api, user, subMsg_1, subModel_5);
            return [new Model(new Area(1, [patternInput_10[0]]), cm.IsBurgerOpen, cm.Errors), Cmd_map((Item_4) => (new Msg(3, [Item_4])), patternInput_10[1])];
        }
        case 6: {
            const patternInput_11 = update_3(api, user, subMsg_2, subModel_7);
            return [new Model(new Area(2, [patternInput_11[0]]), cm.IsBurgerOpen, cm.Errors), Cmd_map((Item_5) => (new Msg(4, [Item_5])), patternInput_11[1])];
        }
        case 7:
            return noCmd(new Model(cm.Area, !cm.IsBurgerOpen, cm.Errors));
        case 8: {
            Infra_clearUserAndSettingsAndRedirect("/");
            return noCmd(cm);
        }
        case 9:
            return noCmd(addError(txt_5, cm));
        case 10:
            return noCmd(addError(ex.message, cm));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, settings, model) {
    let children_40, children_38, children_36, children_14, props_4, children_2, children, props, props_14, children_12, props_38, children_34, children_18, children_32, children_30, children_24, children_28, children_88, props_92, children_86;
    const isQuizzesActive = model.Area.tag === 0;
    const isQuestionsActive = model.Area.tag === 1;
    const isSettingsActive = model.Area.tag === 2;
    const isDonationsActive = model.Area.tag === 3;
    const liClasses = (isActive) => {
        if (isActive) {
            return Helpers_classList([["has-background-light", true], ["has-text-grey-dark", true]]);
        }
        else {
            return Helpers_classList([["has-background-light", false], ["has-text-grey-light", true]]);
        }
    };
    const props_96 = [Helpers_classList([["hero", true], ["is-shadowless", true], ["is-fullheight", true], ["is-dark", true]])];
    const children_90 = [(children_40 = [(children_38 = [(children_36 = [(children_14 = [(props_4 = [new HTMLAttr(94, ["/app/index.html"]), new HTMLAttr(65, ["navbar-item navbar-logo"]), ["style", {
        marginRight: "auto",
    }]], (children_2 = [(children = [(props = [new HTMLAttr(149, ["/logo.png"]), new HTMLAttr(8, ["logo"]), ["style", {
        height: "64px",
        width: "64px",
        maxHeight: "64px",
    }]], react.createElement("img", keyValueList(props, 1)))], react.createElement("figure", {
        className: "image is-64x64",
    }, ...children))], react.createElement("a", keyValueList(props_4, 1), ...children_2))), react.createElement("a", {
        className: "navbar-item is-paddingleft is-hidden-desktop",
    }, user.Name), (props_14 = [new HTMLAttr(135, ["button"]), new HTMLAttr(65, ["navbar-burger has-text-light"]), ["style", {
        marginLeft: "0",
    }], new HTMLAttr(27, ["menu"]), new HTMLAttr(21, [false]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(0, []));
    }])], (children_12 = [react.createElement("span", {
        "aria-hidden": true,
    }), react.createElement("span", {
        "aria-hidden": true,
    }), react.createElement("span", {
        "aria-hidden": true,
    })], react.createElement("a", keyValueList(props_14, 1), ...children_12)))], react.createElement("div", {
        className: "navbar-brand",
    }, ...children_14)), (props_38 = [Helpers_classList([["navbar-menu", true], ["is-active", model.IsBurgerOpen]])], (children_34 = [(children_18 = [react.createElement("a", {
        className: "navbar-item is-hidden-desktop",
        onClick: (_arg_1) => {
            dispatch(new Msg(1, []));
        },
    }, "Logout")], react.createElement("div", {
        className: "navbar-start",
    }, ...children_18)), (children_32 = [(children_30 = [(children_24 = toList(delay(() => {
        let matchValue_4, picture, children_20, props_22;
        return append((matchValue_4 = user.PictureUrl, (matchValue_4 == null) ? (empty_1()) : ((picture = matchValue_4, singleton((children_20 = [(props_22 = [new HTMLAttr(65, ["is-rounded"]), ["style", {
            height: "50px",
            width: "50px",
            maxHeight: "50px",
        }], new HTMLAttr(149, [picture])], react.createElement("img", keyValueList(props_22, 1)))], react.createElement("figure", {
            className: "image",
        }, ...children_20)))))), delay(() => {
            let props_26;
            return singleton((props_26 = [["style", {
                marginLeft: "5px",
            }]], react.createElement("span", keyValueList(props_26, 1), user.Name)));
        }));
    })), react.createElement("a", {
        className: "navbar-link",
    }, ...children_24)), (children_28 = [react.createElement("a", {
        className: "navbar-item has-text-dark",
        onClick: (_arg_2) => {
            dispatch(new Msg(1, []));
        },
    }, "Logout")], react.createElement("div", {
        className: "navbar-dropdown is-boxed",
    }, ...children_28))], react.createElement("div", {
        className: "navbar-item has-dropdown is-hoverable is-hidden-touch",
    }, ...children_30))], react.createElement("div", {
        className: "navbar-end",
    }, ...children_32))], react.createElement("div", keyValueList(props_38, 1), ...children_34)))], react.createElement("nav", {
        className: "navbar is-transparent is-spaced",
        role: "navigation",
        "aria-label": "dropdown navigation",
    }, ...children_36))], react.createElement("div", {
        className: "container",
    }, ...children_38))], react.createElement("div", {
        className: "hero-head",
    }, ...children_40)), (children_88 = [(props_92 = [new HTMLAttr(65, ["container"]), ["style", {
        marginBottom: "auto",
    }]], (children_86 = toList(delay(() => append(map((error) => {
        const children_44 = [react.createElement("button", {
            className: "delete",
            onClick: (_arg_3) => {
                dispatch(new Msg(10, [error[0]]));
            },
        }), error[1]];
        return react.createElement("div", {
            className: "notification is-danger",
        }, ...children_44);
    }, model.Errors), delay(() => {
        let children_84, children_70, children_68, children_66, children_50, props_52, children_54, props_56, children_58, props_60, children_64, props_66, children_62, props_64, children_82;
        return singleton((children_84 = [(children_70 = [(children_68 = [react.createElement("p", {
            className: "menu-label",
        }, "General"), (children_66 = [(children_50 = [(props_52 = [liClasses(isQuizzesActive), new DOMAttr(40, [(_arg_4) => {
            dispatch(new Msg(5, []));
        }])], react.createElement("a", keyValueList(props_52, 1), "Quizzes"))], react.createElement("li", {}, ...children_50)), (children_54 = [(props_56 = [liClasses(isQuestionsActive), new DOMAttr(40, [(_arg_5) => {
            dispatch(new Msg(6, []));
        }])], react.createElement("a", keyValueList(props_56, 1), "Questions"))], react.createElement("li", {}, ...children_54)), (children_58 = [(props_60 = [liClasses(isSettingsActive), new DOMAttr(40, [(_arg_6) => {
            dispatch(new Msg(7, []));
        }])], react.createElement("a", keyValueList(props_60, 1), "Settings"))], react.createElement("li", {}, ...children_58)), (children_64 = [(props_66 = [liClasses(isDonationsActive), new DOMAttr(40, [(_arg_7) => {
            dispatch(new Msg(8, []));
        }])], (children_62 = [(props_64 = [["style", {
            color: "orange",
            fontWeight: "bold",
        }]], react.createElement("div", keyValueList(props_64, 1), "Thanks"))], react.createElement("a", keyValueList(props_66, 1), ...children_62)))], react.createElement("li", {}, ...children_64))], react.createElement("ul", {
            className: "menu-list",
        }, ...children_66))], react.createElement("aside", {
            className: "menu",
        }, ...children_68))], react.createElement("div", {
            className: "column is-narrow",
        }, ...children_70)), (children_82 = toList(delay(() => {
            let children_80, children_74, props_76, props_84, children_78, props_82;
            const matchValue_5 = model.Area;
            return (matchValue_5.tag === 1) ? singleton(view_1((arg_1) => {
                dispatch(new Msg(3, [arg_1]));
            }, user, settings, matchValue_5.fields[0])) : ((matchValue_5.tag === 2) ? singleton(view_2((arg_2) => {
                dispatch(new Msg(4, [arg_2]));
            }, user, settings, matchValue_5.fields[0])) : ((matchValue_5.tag === 3) ? singleton((children_80 = [(children_74 = ["If you want to appreciate work open-quiz author did, you may send him an ", (props_76 = [["style", {
                textDecoration: "underline",
            }], new HTMLAttr(94, ["https://www.amazon.com/s?rh=n%3A15382616011%2Cp_n_format_browse-bin%3A2740964011&qid=1615299401&rnid=2740963011&ref=lp_15382616011_nr_p_n_format_browse-bin_0"])], react.createElement("a", keyValueList(props_76, 1), "Amazon\'s eGift Card")), "."], react.createElement("div", {
                className: "subtitle",
            }, ...children_74)), react.createElement("div", {}, "Here is video-instruction"), (props_84 = [new HTMLAttr(71, [true]), new HTMLAttr(56, [true]), ["style", {
                width: "800px",
            }]], (children_78 = [(props_82 = [new HTMLAttr(149, [Infra_urlForMediaPlain(settings.MediaHost, "amazon-thx.mov")]), new HTMLAttr(159, ["video/mp4"])], react.createElement("source", keyValueList(props_82, 1)))], react.createElement("video", keyValueList(props_84, 1), ...children_78)))], react.createElement("div", {}, ...children_80))) : singleton(view_3((arg) => {
                dispatch(new Msg(2, [arg]));
            }, user, settings, matchValue_5.fields[0]))));
        })), react.createElement("div", {
            className: "column",
        }, ...children_82))], react.createElement("div", {
            className: "columns",
        }, ...children_84)));
    })))), react.createElement("div", keyValueList(props_92, 1), ...children_86)))], react.createElement("div", {
        className: "hero-body",
    }, ...children_88)), footerHero];
    return react.createElement("section", keyValueList(props_96, 1), ...children_90);
}

